import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import classNames from 'classnames';

import { AppointmentChatButton } from 'features/order-tracker/shared-components';
import { CHAT_BLACK_LINK, CHAT_WHITE_LINK } from 'features/order-tracker/shared-components/LivePersonChat/constants';
import { NotificationInfoIcon, SimpleCloseIcon, SuccessCheckIcon } from 'features/order-tracker/shared-components/svg';
import { hideNotification } from 'features/order-tracker/store/actions';
import { useLivePersonPageChange } from 'features/order-tracker/store/hooks/useLivePersonPageChange';
import { AppointmentAnalyticService } from 'features/order-tracker/store/sagas/services/appointmentAnalyticsService';
import { getAmendAppointmentNotificationType } from 'features/order-tracker/store/selectors';

import { ERROR_CHAT, ICON_COLOR, LIST_OF_TYPES_WITH_CHAT_BUTTON, NOTIFICATION_CONTENT, SUCCESS } from './constants';

import styles from './styles.module.scss';

export const Notification: React.FC = () => {
  const bannerRef = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();
  const type = useSelector(getAmendAppointmentNotificationType);
  const hasChatButton = LIST_OF_TYPES_WITH_CHAT_BUTTON.some(item => type === item);

  const handleHideNotification = (): void => {
    dispatch(hideNotification());
  };

  useEffect(() => {
    type && useLivePersonPageChange();
  }, [type]);

  useEffect(() => {
    type &&
      bannerRef &&
      AppointmentAnalyticService.trackAmendApptApiError({
        ref: bannerRef,
        modal: NOTIFICATION_CONTENT[type].analytics,
        value: NOTIFICATION_CONTENT[type].message,
      });
  }, [type, bannerRef]);

  if (!type) {
    return null;
  }

  const chatButtonType = type === ERROR_CHAT ? CHAT_WHITE_LINK : CHAT_BLACK_LINK;
  const notificationIcon =
    type === SUCCESS ? (
      <SuccessCheckIcon className={styles.successIcon} />
    ) : (
      <NotificationInfoIcon color={ICON_COLOR[type]} />
    );

  return (
    <div ref={bannerRef} className={classNames(styles.notificationContainer, styles[type])}>
      <div>
        <div>{notificationIcon}</div>
        <div className={styles.notificationContent}>
          <h4>{NOTIFICATION_CONTENT[type].title}</h4>
          <p>{NOTIFICATION_CONTENT[type].message}</p>
          {hasChatButton && <AppointmentChatButton type={chatButtonType} />}
        </div>
      </div>
      <button data-testid="closeIcon" onClick={handleHideNotification} type="button" className={styles.closeButton}>
        <SimpleCloseIcon color={ICON_COLOR[type]} />
      </button>
    </div>
  );
};
